import React from 'react';
import { Link } from 'react-router-dom';
import { Waves, Mail, Phone, MapPin } from 'lucide-react';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="bg-slate-900/50 border-t border-slate-800 py-12 px-6 md:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} alt="OceanTech" className="h-10 w-auto object-contain" />
            </div>
            <p className="text-sm text-slate-400">
              Connecting exceptional talent with world-class opportunities.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                Home
              </Link>
              <Link to="/jobs" className="block text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                Jobs
              </Link>
              <Link to="/services" className="block text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                Services
              </Link>
              <Link to="/about" className="block text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                About
              </Link>
              <Link to="/contact" className="block text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">For Candidates</h3>
            <div className="space-y-2">
              <Link to="/jobs" className="block text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                Browse Jobs
              </Link>
              <Link to="/register" className="block text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                Create Account
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <a href="mailto:support@oceantechsolution.com" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                <Mail className="w-4 h-4" />
                support@oceantechsolution.com
              </a>
              <a href="tel:+917069291955" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-500 transition-colors">
                <Phone className="w-4 h-4" />
                +910001112223
              </a>
              <div className="flex items-start gap-2 text-sm text-slate-400">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>31 Pine Grove Rd#1048<br />Locust Grove, GA 30248</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-sm text-slate-400">
            &copy;OCEANTECH <br /> All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;